angular.module('unergie.main')
.constant('RoomName', {
    'Logement': 'housing',
    'Cuisine': 'kitchen',
    'Salle de bain': 'bathroom',
    'Chambre': 'bedroom',
    'Pièce à vivre': 'living',
})
.constant('ImplementationToText', {
    1: 'Facile',
    2: 'Moyenne',
    3: 'Difficile',
})
.constant('InvoiceStatus', {
    done: 50,
    partial: 54,
})
.constant('DealStatuses', {
    PRM_KO: { title: 'Pas de PDL ou PDL inéligible', description: `Le PDL (PRM) n'est pas éligible ou absent de l'ébauche de contrat` },
    WITHOUT_PRM_ESTIMATION: { title: 'Devis sans PDL', description: `Devis en attente de finalisation (ajout du PDL et signature)` },
    DRAFT: { title: 'Souscription initiée', description: `Parcours de souscription non finalisé` },
    CLIENT_CHECKOUT: { title: 'Contrat à signer', description: `En attente de la signature du contrat par le prospect` },
    CONTRACT_OK: { title: 'À transmettre à Enedis', description: `La commande est en préparation chez Plüm, avant envoi à Enedis` },
    CONTRACT_PROCESSED: { title: 'Transmis à Enedis', description: `La commande est en cours de traitement chez Enedis` },
    CONTRACT_PROCESSED_LATE: { title: 'Retard Enedis', description: `Le délai de traitement Enedis est anormalement long` },
    WAITING_RETRACT: { title: 'Délai de retractation', description: `Attente de la fin du délai de rétractation` },
    ENEDIS_ERROR: { title: 'Erreur Enedis', description: `Erreur Enedis` },
    DUPLICATE: { title: 'Duplicat', description: `Un contrat non résilié avec le même PDL existe déjà chez Plüm` },
    WAITING_SWITCH_READINGS: { title: 'Attente client (Relève)', description: `Enedis impose une auto-relève pour prendre la commande` },
    CONTRACT_PROCESSING: { title: 'Attente client (RDV)', description: `RDV a prendre pour l'intervention Enedis` },
    DEAL_FINISHED_OK: { title: 'Contrat Actif', description: `Le contrat du client est actif` },
    UNREACHABLE: { title: 'Client injoignable', description: `Le client est injoignable, l'ébauche de contrat va être effacée.` },
    RETRACTED: { title: 'Contrat rétracté', description: `Le prospect a annulé sa souscription pendant la période de rétractation` },
    CANCELLED: { title: 'Contrat annulé', description: `Le contrat a été annulé` },
    UNCLEAR: { title: 'Indéfini', description: `` },
})
.constant('CommonRegex', {
    fullname: /^[a-zA-ZÀ-ÿ][ 'a-zA-ZÀ-ÿ-]*['a-zA-ZÀ-ÿ]$/i,
    phone: {
        french: /^(0|\+33)[1-79][0-9]{8}$/,
        mobiles: /^(0|\+33)[6-7][0-9]{8}$/,
        international: /^\+\d{8,15}$/,
    },
    email: /^(([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))+$/,
    bic: /^\w{8}(?:\w{3})?$/, // 8 ou 11 caractère (pas entre les 2)
    naf: /^\d{4}[A-Z]$/,
    siret: /^\d{14}$/,
})
.constant('PrmValidationConstants', {
    KO_ENEDIS_STATUSES: [
        'PDL résilié',
        'PDL en cours de résiliation',
        'PDL en cours de raccordement',
        'PDL innacessible SGE',
        'PDL inéligible',
        'PDL avec n° de PDL non conforme',
        'PDL raccordé au réseau haute tension (HTA)',
        'PDL jugé inexistant par le GRD',
        'Segment non permis par votre marché',
    ],
})
.constant('ContactInformationB2G', {
    default_B2B: {
        name: 'B2B',
        hours: '9h à 17h',
        phone: '01 76 49 01 09',
        email: 'client-entreprise@plum.fr',
        emergencyPhone: '09 72 67 50 93',
    },
    default_B2G: {
        name: 'B2G',
        hours: '9h à 17h',
        phone: '01 76 41 06 24',
        email: 'collectivites@plum-energie.com',
        emergencyPhone: '09 72 67 50 93',
    },
})
.constant('Roles', {
    'data-admin': { label: 'ADMIN - Super Admin', home: 'contracts' },
    'product-owner': { label: 'ADMIN - Produit', home: 'contracts' },
    'data-reader': { label: 'ADMIN - Lecture seule', home: 'csr-b2c-home' },
    'b2g-billing-admin': { label: 'ADMIN - Responsable Facturation', home: 'csr-b2g-home' },
    'team-b2bg': { label: 'ADMIN - Équipe B2BG', home: 'csr-b2g-home' },
    'accountant': { label: 'ADMIN - Comptable', home: 'b2gBankDetails' },
    'csr-n3': { label: 'CSR - Chargé de clientèle niv. 3', home: 'csr-b2c-home' },
    'csr-expert-admin': { label: 'CSR - Chargé de clientèle niv. 2 senior', home: 'csr-b2c-home' },
    'csr-expert': { label: 'CSR - Chargé de clientèle niv. 2', home: 'csr-b2c-home' },
    'csr-admin': { label: 'CSR - Admin chargé de clientèle', home: 'csr-b2c-home' },
    'csr': { label: 'CSR - Chargé de clientèle', home: 'csr-b2c-home' },
    'advisor-admin': { label: 'VENTE - Admin vente', home: 'sales-tunnel-v2' },
    'advisor': { label: 'VENTE - Vendeur', home: 'sales-tunnel-v2' },
    'partner-advisor': { label: 'VENTE - Vendeur partenaire', home: 'sales-tunnel-v3' },
    'partner-advisor-admin': { label: 'VENTE - Admin vendeur partenaire', home: 'affaires' },
    'b2g-coordinator': { label: 'B2G - Coordonateur', home: 'b2g-home-v2' },
    'managed-account': { label: 'B2G - Compte de facturation', home: 'b2g-home-v2' },
    'manager-admin': { label: 'B2G - Membre Administrateur', home: 'b2g-home-v2' },
    'manager-expert': { label: 'B2G - Membre expert', home: 'b2g-home-v2' },
    'manager': { label: 'B2G - Membre', home: 'b2g-home-v2' },
    'manager-reader': { label: 'B2G - Membre lecture seule', home: 'pdls' },
    'csr-b2g-admin': { label: 'B2G - Admin chargé de clientèle B2G', home: 'csr-b2g-home' },
    'csr-b2g': { label: 'B2G - Chargé de clientèle B2G', home: 'csr-b2g-home' },
    'marketing-admin': { label: 'MKT - Responsable Marketing', home: 'csr-b2c-home' },
    'marketing': { label: 'MKT - Marketing', home: 'csr-b2c-home' },
    'bulk-purchase-admin': { label: 'VENTE AG - Gestionnaire admin', home: 'directory' },
    'bulk-purchase': { label: 'VENTE AG - Gestionnaire', home: 'directory' },
    'technical-external': { label: 'TECH - Compte technique (sans accès BO)', home: 'N/A' },
})
